import {
    SHOW_LOADER_DELIVERY_TYPES,
    HIDE_LOADER_DELIVERY_TYPES,
    SET_DELIVERY_TYPES,
    PUT_FORM_DELIVERY_DATA,
    PUT_INPUT_SEARCH_NP,
    SET_NP_CITIES,
    VALIDATE_FORM_DATA,
    SET_NP_WAREHOUSES,
    SELECT_NP_WAREHOUSE,
    REDIRECT_TO_PAYMENT,
    HIDE_LOADER_CHECKOUT,
    REDIRECT_TO_OFFLINE_STATUS, SETS_LOCAL_SHOP_ACTION, PRELOAD_USER_DATA, NP_LOADER_START
} from "../actions/checkout";
import { withTranslation } from 'react-i18next';


const initialState = {
    deliveryTypes: {},
    showLoaderDeliveryTypes: true,
    formData: {'delivery_type' : 0},
    inputSearchNp: '',
    npCities: [],
    warehouses: [],
    warehouse: {},
    validationData: [],
    isRedirectOnline: false,
    isRedirectOffline: false,
    loaderCheckoutStartAction: false,
    showNPCityLoader: false
};

//const { t } = this.props;

export default function getCheckoutInfo(state = initialState, action){
    switch ( action.type ) {
        case SET_DELIVERY_TYPES:
            return {
                ...state,
                deliveryTypes: action.deliveryTypes,
                showLoaderDeliveryTypes: false
            };
            break;
        case SHOW_LOADER_DELIVERY_TYPES:
            return {
                ...state,
                showLoaderDeliveryTypes: true
            }
            break;

        case HIDE_LOADER_DELIVERY_TYPES:
            return {
                ...state,
                showLoaderDeliveryTypes: false
            }
            break;

        case PUT_FORM_DELIVERY_DATA:
            return {
                ...state,
                formData: Object.assign({}, state.formData, {[action.data.name]: action.data.value})
            }
            break;

        case PUT_INPUT_SEARCH_NP:
            return {
                ...state,
                inputSearchNp: action.value
            }
            break;

        case SET_NP_CITIES:
            return {
                ...state,
                npCities: action.data,
                showNPCityLoader: false
            }
            break;

        case VALIDATE_FORM_DATA:
            var validationData = validateFormData(state);
            return {
                    ...state,
                    validationData:validationData.data,
                    hasError: validationData.hasError,
                    loaderCheckoutStartAction: !validationData.hasError
                }
            break;
        case HIDE_LOADER_CHECKOUT:
                return {
                    ...state,
                    loaderCheckoutStartAction: false
                }
            break;
        case SET_NP_WAREHOUSES:
            return {
                ...state,
                warehouses: action.warehouses,
                showNPCityLoader: false,
                formData: Object.assign({}, state.formData, {'np_warehouses': null})
            }
            break;
        case SELECT_NP_WAREHOUSE:
            return {
              ...state,
              warehouse: action.warehouse
            }
        break;

        case REDIRECT_TO_PAYMENT:
            return {
                ...state,
                isRedirectOnline: true,
                orderIdCreated: action.orderId
            }
            break;

        case REDIRECT_TO_OFFLINE_STATUS:
            return {
                ...state,
                isRedirectOffline: true,
                orderIdCreated: action.orderId
            }
        break;

        case SETS_LOCAL_SHOP_ACTION:
            return {
                ...state,
                shopsLocal: action.data,
                showNPCityLoader: false
            }
            break;
        case NP_LOADER_START:
            return {
                ...state,
                showNPCityLoader: true
            }
            break;
        case PRELOAD_USER_DATA:
            return {
                ...state,
                formData: {
                    firstName: action.data.name,
                    secondName: action.data.second_name,
                    phone:action.data.phone,
                    email: action.data.email
                }
            }
        default:
            return state;
    }
}

const validateFormData = (state) => {
    const requiredFields = ['delivery_type','delivery_city','email','firstName','phone','secondName', 'np_warehouses', 'local_shops'];
    var validation = [];
    var hasError = false;
    // console.log('state formData', state.formData);
    requiredFields.forEach( itm => {
        validation[itm] = [];
        validation[itm]['passed'] = true ;
        validation[itm]['error'] = false ;
        switch ( itm ) {
            case 'email':
                return false;
                var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if ( state.formData[itm] === undefined && state.formData['phone'] === undefined ){
                    validation[itm]['passed'] = false;
                    validation[itm]['error'] = 'checkout.empty_email';
                    hasError = true;
                }else if ( state.formData[itm] !== undefined && !re.test(state.formData[itm]) ){
                    validation[itm]['passed'] = false;
                    validation[itm]['error'] = 'checkout.wrong_email_format';
                    hasError = true;
                }
                break;

            case 'delivery_type':
                if ( state.formData[itm] === undefined || state.formData[itm] === 0 ){
                    validation[itm]['passed'] = false;
                    validation[itm]['error'] = 'checkout.choose_delivery_type';
                    hasError = true;
                }
                break;

            case 'delivery_city':
                if ( state.formData[itm] === undefined && state.formData['delivery_type'] === '3' ){
                    validation[itm]['passed'] = false;
                    validation[itm]['error'] = 'chekcout.choose_city_to_delivery';
                    hasError = true;
                }
                break;

            case 'firstName':
                if (state.formData[itm] === undefined || state.formData[itm] === ''){
                    validation[itm]['passed'] = false;
                    validation[itm]['error'] = 'chekcout.empty_name_is_not_allowed';
                    hasError = true;
                }
                break ;

            case 'secondName':
                if (state.formData[itm] === undefined || state.formData[itm] === ''){
                    validation[itm]['passed'] = false;
                    validation[itm]['error'] = 'chekcout.empty_name_is_not_allowed';
                    hasError = true;
                }
                break;

            case 'phone':
                if ( state.formData[itm] === undefined && state.formData['email'] === undefined ){
                    validation[itm]['passed'] = false;
                    validation[itm]['error'] = 'checkout.phone_number_is_not_correct';
                    hasError = true;
                }else{
                    let reg = /\+\d{12,16}/;
                    if ( !reg.test(state.formData[itm]) && state.formData[itm] !== undefined ){
                        validation[itm]['passed']= false;
                        validation[itm]['error'] = 'checkout.wrong_phone_format';
                        hasError = true;
                    }
                }
                break;

            case 'np_warehouses':
                if (state.formData[itm] === undefined && state.formData['delivery_type'] === '3' ){
                    validation[itm]['passed'] = false;
                    validation[itm]['error'] = 'checkout.choose_warehouses';
                    hasError = true;
                }
                break;
            case 'local_shops':
                if (state.formData[itm] === undefined && state.formData['delivery_type'] === '1' ){
                    validation[itm]['passed'] = false;
                    validation[itm]['error'] = 'checkout.choose_local_shop';
                    hasError = true;
                }
                break;
            default:
                break;
        }
    });
    return { data: validation, hasError: hasError};
}
